import { render, staticRenderFns } from "./MsinList.vue?vue&type=template&id=35c995f5&scoped=true&"
import script from "./MsinList.vue?vue&type=script&lang=js&"
export * from "./MsinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c995f5",
  null
  
)

export default component.exports